import { useSelector } from 'react-redux';

import { makeGetSubscriptionIsExpired, makeGetIsOnTrial, makeGetCurrentPlanId, makeGetIsOnFreePlan, makeGetRemainingTrial } from 'selectors/billing';

import { useCurrentTeam, useCurrentPlanProps } from 'shared-hooks/team';
import { useCurrentUser } from 'shared-hooks/user';

import { getSubscriptionPrice } from 'utils/billing';
import { getToday } from 'utils/date';

const getSubscriptionIsExpired = makeGetSubscriptionIsExpired();
const getIsOnTrial = makeGetIsOnTrial();
const getRemainingTrial = makeGetRemainingTrial();
const getCurrentPlanId = makeGetCurrentPlanId();
const getIsOnFreePlan = makeGetIsOnFreePlan();

export const useSubscriptionIsExpired = () => {
    const currentTeam = useCurrentTeam();
    const isExpired = useSelector(() => getSubscriptionIsExpired(currentTeam, false));

    return isExpired;
};

export const useIsOnTrial = () => {
    const currentTeam = useCurrentTeam();
    const isOnTrial = useSelector(() => getIsOnTrial(currentTeam));

    return isOnTrial;
}

export const useRemainingTrial = () => {
    const currentTeam = useCurrentTeam();
    const remainingTrial = useSelector(() => getRemainingTrial(currentTeam, getToday()));

    return remainingTrial;
}

export const useIsOnFreePlan = () => {
    const currentTeam = useCurrentTeam();
    const isOnFreePlan = useSelector(() => getIsOnFreePlan(currentTeam));

    return isOnFreePlan;
}

export const useIsBillingOwner = () => {
    const currentTeam = useCurrentTeam();
    const currentUser = useCurrentUser();
    const isOnFreePlan = useIsOnFreePlan();
    const isOnTrial = useIsOnTrial();
    const isExpired = useSubscriptionIsExpired();

    if (currentUser?.role === 'client') {
        return false;
    }

        return isOnTrial || isOnFreePlan || isExpired || currentUser?.id === (currentTeam?.billing_owner || currentTeam?.owner);
};

export const usePlanTotalProjects = () => {
    const planProps = useCurrentPlanProps();

    if (!planProps?.quota?.projects) {
        return Number.POSITIVE_INFINITY;
    }

    return planProps.quota.projects;
}

export const useIsAnnualSubscription = () => {
    const currentTeam = useCurrentTeam();

    return currentTeam?.plan_details?.billing_period === 'year';
}

export const useSubscriptionPrice = () => {
    const currentTeam = useCurrentTeam();

    return getSubscriptionPrice(currentTeam?.plan_details, currentTeam?.discount)
}
